import React from "react";
import StatusToggle from "./StatusToggle";

export default function EmailTemplateTable({
  templates,
  onEdit,
  onToggleStatus
}) {
  return (
    <table className="w-full border">

      <thead className="bg-gray-100">
        <tr>
          <th className="p-2 text-left">Use Case</th>
          <th className="p-2 text-left">Category</th>
          <th className="p-2 text-left">Subject</th>
          <th className="p-2 text-left">Status</th>
          <th className="p-2 text-left">Actions</th>
        </tr>
      </thead>

      <tbody>
        {templates.map(t => (
          <tr key={t.id} className="border-t">

            <td className="p-2">{t.useCase}</td>
            <td className="p-2">{t.category}</td>
            <td className="p-2">{t.subjectTemplate}</td>

            <td className="p-2">
              <StatusToggle
                value={t.isActive}
                onChange={(val) =>
                  onToggleStatus(t.id, val)
                }
              />
            </td>

            <td className="p-2">
              <button
                onClick={() => onEdit(t)}
                className="text-blue-600"
              >
                Edit
              </button>
            </td>

          </tr>
        ))}
      </tbody>

    </table>
  );
}